import { SearchOff } from '../../../../primitives/index.js'
import classes from './noresults.module.css'

export function NoResults(props: { search: string }) {
  const { search } = props

  return (
    <div className={classes.stack}>
      <SearchOff className={classes.icon} />

      <p className={classes.text}>
        No results for &quot;
        <span className={classes.bold}>{search}</span>
        &quot;.
      </p>
    </div>
  )
}
